export const version = '0.749.0'
export const chameleonWebVersion = '8.8.4'
export const chameleonCoreVersion = '7.6.0'
